import { isString } from 'helpers';

import { IntakeFormKey } from 'constants/intake-form';

type Question = {
    question: string;
    value: string | Array<string> | { unit: any; height: any; weight: any };
};

type Props = {
    key: string;
    itemQuestion: Question;
};
export const useSaveAnswers = () => {
    let questions = localStorage.getItem(IntakeFormKey);

    if (!questions) {
        localStorage.setItem(IntakeFormKey, JSON.stringify({}));
        questions = localStorage.getItem(IntakeFormKey);
    }

    return (props: Props) => {
        const questionsObj = JSON.parse(questions as string) as { [key: string]: Question };

        let value = Array.isArray(props.itemQuestion.value) ? props.itemQuestion.value.join(', ') : props.itemQuestion.value;

        if (isString(value)) {
            // @ts-ignore
            value = value.replace('“', '"').replace('”', '"').replace('’', "'");
        }

        const question = props.itemQuestion.question
            .replace(/<[^>]*>?/gm, '')
            .replace('“', '"')
            .replace('”', '"')
            .replace('’', "'");

        questionsObj[props.key] = { question, value };

        localStorage.setItem(IntakeFormKey, JSON.stringify(questionsObj));
    };
};
